import { of } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { map, catchError } from 'rxjs/operators';
import { ConstantValues } from '../bpg-common/models/bpg-constants';
import { BpgCommonService } from '../bpg-common/services/bpg-common.service';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../bpg-common/services/bpg-common.service";
var EXCEL_TYPE = 'application/csv;charset=UTF-8';
var EXCEL_EXTENSION = '.csv';
var SelfService = /** @class */ (function () {
    function SelfService(http, 
    // private logger: BPGLoggerService,
    bpgCommonService) {
        this.http = http;
        this.bpgCommonService = bpgCommonService;
        this.URI = ConstantValues.userManagementApiUrl.userManagementUrl;
        this.areaOfImpactListApi = ConstantValues.userManagementApiUrl.areaOfImpactList;
        this.areaOfImpactSaveApi = ConstantValues.userManagementApiUrl.saveAreaOfImpact;
        this.areaOfImpactDeleteApi = ConstantValues.userManagementApiUrl.deleteAreaOfImpact;
        this.demographicsListApi = ConstantValues.userManagementApiUrl.demographicsList;
        this.demographicsSaveApi = ConstantValues.userManagementApiUrl.saveDemographic;
        this.demographicsDeleteApi = ConstantValues.userManagementApiUrl.deleteDemographic;
        this.bpgListApi = ConstantValues.userManagementApiUrl.bpgList;
        this.bpgSaveApi = ConstantValues.userManagementApiUrl.saveBpg;
        this.bpgDeleteApi = ConstantValues.userManagementApiUrl.deleteBpg;
        this.skillListApi = ConstantValues.userManagementApiUrl.skillList;
        this.skillSaveApi = ConstantValues.userManagementApiUrl.saveSkill;
        this.skillDeleteApi = ConstantValues.userManagementApiUrl.deleteSkill;
        this.userListApi = ConstantValues.userManagementApiUrl.userList;
        this.siteSaveApi = ConstantValues.userManagementApiUrl.siteSave;
        this.siteListApi = ConstantValues.userManagementApiUrl.siteList;
        this.siteDeleteApi = ConstantValues.userManagementApiUrl.deleteSite;
        this.chapterListApi = ConstantValues.userManagementApiUrl.chapterList;
        this.chapterSaveApi = ConstantValues.userManagementApiUrl.saveChapter;
        this.chapterDeleteApi = ConstantValues.userManagementApiUrl.deleteChapter;
        this.landingData = ConstantValues.membershipApiUrl.landingDto;
        this.listAllSitesApi = ConstantValues.userManagementApiUrl.listAllSites;
        this.listAllChaptersApi = ConstantValues.userManagementApiUrl.listAllChapters;
        this.listFullChaptersApi = ConstantValues.userManagementApiUrl.listFullChapters;
        this.bpgPageApi = ConstantValues.userManagementApiUrl.bpgListPage;
        this.skillPageApi = ConstantValues.userManagementApiUrl.skillListPage;
        this.areaOfImpactPageApi = ConstantValues.userManagementApiUrl.areaOfImpactListPage;
        this.chapterListByBpgApi = ConstantValues.userManagementApiUrl.chapterListByBpg;
        this.diSaveApi = ConstantValues.userManagementApiUrl.diSave;
        this.diAddMasterApi = ConstantValues.userManagementApiUrl.diAdd;
        this.diAddNewsApi = ConstantValues.userManagementApiUrl.diNewsAdd;
        this.diAddResourceApi = ConstantValues.userManagementApiUrl.diResourceAdd;
        this.diReTeamAddApi = ConstantValues.userManagementApiUrl.diReTeamAdd;
        this.diNaacAddApi = ConstantValues.userManagementApiUrl.diNaacAdd;
        this.getDiMasterListApi = ConstantValues.userManagementApiUrl.getDiMasterList;
        this.getDiNewsListApi = ConstantValues.userManagementApiUrl.getDiNewsList;
        this.getDiResouceListApi = ConstantValues.userManagementApiUrl.getDiResouceList;
        this.getReteamListApi = ConstantValues.userManagementApiUrl.getReteamList;
        this.getNaacListApi = ConstantValues.userManagementApiUrl.getNaacList;
        this.deleteDiApi = ConstantValues.userManagementApiUrl.deleteDi;
        this.addGalleryApi = ConstantValues.userManagementApiUrl.addGallery;
        this.getGalleryListApi = ConstantValues.userManagementApiUrl.getGalleryList;
        this.deleteChapterGallery = ConstantValues.userManagementApiUrl.deleteChapterGallery;
        this.addDocumentsFolderApi = ConstantValues.userManagementApiUrl.addDocumentsFolder;
        this.getDocumentsFolderListApi = ConstantValues.userManagementApiUrl.getDocumentsFolderList;
        this.deleteDocumentsFolderApi = ConstantValues.userManagementApiUrl.deleteDocumentsFolder;
        this.membershipReportApi = ConstantValues.userManagementApiUrl.membershipReport;
        this.getBannerListApi = ConstantValues.userManagementApiUrl.getBannerList;
        this.deleteBannerApi = ConstantValues.userManagementApiUrl.deleteBannerList;
        this.addDiDocumentsFolderApi = ConstantValues.userManagementApiUrl.addDiDocumentsFolder;
        this.getDiDocumentsFolderApi = ConstantValues.userManagementApiUrl.getDiDocumentsFolder;
        this.deleteDiDocumentsFolderApi = ConstantValues.userManagementApiUrl.deleteDiDocumentsFolder;
        this.siteMapApi = ConstantValues.userManagementApiUrl.siteMap;
        this.eachBpgApi = ConstantValues.userManagementApiUrl.eachBpg;
        this.naacAddAffinityApi = ConstantValues.userManagementApiUrl.naacAddAffinity;
        this.addnaacMasterApi = ConstantValues.userManagementApiUrl.addnaacMaster;
        this.addnaacNewsApi = ConstantValues.userManagementApiUrl.addnaacNews;
        this.addnaacReTeamApi = ConstantValues.userManagementApiUrl.addnaacReTeam;
        this.addnaacResourceApi = ConstantValues.userManagementApiUrl.addnaacResource;
        this.getnaacBannerListApi = ConstantValues.userManagementApiUrl.getnaacBannerList;
        this.getnaacNewsApi = ConstantValues.userManagementApiUrl.getnaacNews;
        this.getnaacREteamApi = ConstantValues.userManagementApiUrl.getnaacREteam;
        this.getnaacResourceApi = ConstantValues.userManagementApiUrl.getnaacResource;
        this.getnaacAffinityListApi = ConstantValues.userManagementApiUrl.getnaacAffinity;
        this.deleteNaacBannerApi = ConstantValues.userManagementApiUrl.deleteNaacBanner;
        this.deletenaacApi = ConstantValues.userManagementApiUrl.deletenaac;
        this.addNaacDocumentsFolderApi = ConstantValues.userManagementApiUrl.addNaacDocumentsFolder;
        this.getNaacDocumentsFolderApi = ConstantValues.userManagementApiUrl.getNaacDocumentsFolder;
        this.deleteNaacDocumentsFolderApi = ConstantValues.userManagementApiUrl.deleteNaacDocumentsFolder;
        this.deleteNaacAffinityApi = ConstantValues.userManagementApiUrl.deleteNaacAffinity;
        this.getMapDataforNaacApi = ConstantValues.userManagementApiUrl.getMapDataforNaac;
        this.getsiteDetailsApi = ConstantValues.userManagementApiUrl.getsiteDetails;
        this.getSummaryDetailsApi = ConstantValues.userManagementApiUrl.getSummaryDetails;
        this.getNaacEventsApi = ConstantValues.userManagementApiUrl.getNaacEvents;
        this.getAllNaacApi = ConstantValues.userManagementApiUrl.naacList;
        this.addChapterAnnouncementApi = ConstantValues.userManagementApiUrl.addChapterAnnouncement;
        this.getChapterAnnouncementListApi = ConstantValues.userManagementApiUrl.getChapterAnnouncement;
        this.deleteChapterAnnouncementApi = ConstantValues.userManagementApiUrl.deleteChapterAnnouncement;
        this.sendChapterFeedbackApi = ConstantValues.userManagementApiUrl.sendChapterFeedback;
        this.getChapterFeedbackApi = ConstantValues.userManagementApiUrl.getChapterFeedback;
        this.sendChapterNotificationApi = ConstantValues.userManagementApiUrl.sendChapterNotification;
        this.addChapterBoardMemberApi = ConstantValues.userManagementApiUrl.addChapterBoardMember;
        this.getChapterBoardMemberApi = ConstantValues.userManagementApiUrl.getChapterBoardMember;
        this.deleteChapterBoardMemberApi = ConstantValues.userManagementApiUrl.deleteChapterBoardMember;
        this.getChapterStatusApi = ConstantValues.userManagementApiUrl.getChapterStatus;
        this.trackPostCastViewsApi = ConstantValues.userManagementApiUrl.trackPostCastViews;
        this.getUserDtlsApi = ConstantValues.userManagementApiUrl.getUserDtls;
        this.updateNewSiteApi = ConstantValues.userManagementApiUrl.updateNewSite;
        // getNotEnrolledBpgApi: string = ConstantValues.userManagementApiUrl.getNotEnrolledBpg;
        this.getVirtualBpgApi = ConstantValues.userManagementApiUrl.getVirtualBpg;
        this.getEnrolledBpgApi = ConstantValues.userManagementApiUrl.getEnrolledBpg;
        this.saveMembershipApi = ConstantValues.userManagementApiUrl.saveMembership;
        this.membershipSitesApi = ConstantValues.userManagementApiUrl.getMembershipsites;
    }
    /** For service call to GET areas of impact
      * @class AreaOfImpactService
      * @method getAllAreaOfImpact
      * @param landingData
      * @returns Observable
      */
    SelfService.prototype.getAllAreaOfImpact = function (landingData) {
        return this.http.post(this.URI + this.areaOfImpactListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to SAVE areas of impact
     * @class AreaOfImpactService
     * @method saveAllAreaOfImpact
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.saveAllAreaOfImpact = function (landingData) {
        return this.http.post(this.URI + this.areaOfImpactSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Saving area of impact list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete areas of impact
      * @class AreaOfImpactService
      * @method deleteAllAreaOfImpact
      * @param landingData
      * @returns Observable
      */
    SelfService.prototype.deleteAllAreaOfImpact = function (id) {
        return this.http.delete(this.URI + this.areaOfImpactDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to getAllDemographics
     * @class DemographicsService
     * @method listDemographics
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.getAllDemographics = function () {
        return this.http.post(this.URI + this.demographicsListApi, this.landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to save All Demographics
     * @class DemographicsService
     * @method saveDemographics
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.saveAllDemographics = function (landingData) {
        return this.http.post(this.URI + this.demographicsSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to deleteDemographic
    * @class DemographicsService
    * @method deleteDemographics
    * @param id
    * @returns Observable
    */
    SelfService.prototype.deleteDemographic = function (id) {
        return this.http.delete(this.URI + this.demographicsDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to GET BPG's
      * @class BPGService
      * @method getAllBpg
      * @param landingData
      * @returns Observable
      */
    SelfService.prototype.getAllBpg = function (landingData) {
        return this.http.post(this.URI + this.bpgListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting bpg list failed in bpg.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET BPG's
    * @class BPGService
    * @method getAllBpg
    * @param landingData
    * @returns Observable
    */
    //  public getNotEnrolledBpg(siteId,userId): Observable<any> {
    //    let params = siteId + '/' + userId
    //       return this.http.get(this.URI + this.getNotEnrolledBpgApi + params, this.bpgCommonService.tokenizedHeader()).pipe(map((data: any) => {
    //           return data;
    //       })).pipe(catchError((error: any) => {
    //           throw of(error);
    //       }))
    // }
    /** For service call to GET BPG's
    * @class BPGService
    * @method getAllBpg
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.getVirtualBpgs = function (userId) {
        return this.http.get(this.URI + this.getVirtualBpgApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to POST Membership Form
  * @class BPGService
  * @method saveMembership
  * @param landingData
  * @returns Observable
  */
    SelfService.prototype.saveMembership = function (membershipData) {
        return this.http.post(this.URI + this.saveMembershipApi, membershipData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to GET BPG's
  * @class BPGService
  * @method getAllBpg
  * @param landingData
  * @returns Observable
  */
    SelfService.prototype.getEnrolledBpg = function (userId) {
        return this.http.get(this.URI + this.getEnrolledBpgApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to GET NAAC's
    * @class BPGService
    * @method getAllNaac
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.getAllNaac = function (landingData) {
        return this.http.post(this.URI + this.getAllNaacApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting bpg list failed in bpg.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to SAVE BPG
     * @class BPGService
     * @method saveAllBpg
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.saveAllBpg = function (landingData) {
        return this.http.post(this.URI + this.bpgSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Saving bpg list failed in bpg.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete BPG
    * @class BPGService
    * @method deleteBpg
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.deleteBpg = function (id) {
        return this.http.delete(this.URI + this.bpgDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to GET SKILL
  * @class SkillsService
  * @method getAllSkill
  * @param landingData
  * @returns Observable
  */
    SelfService.prototype.getAllSkill = function (landingData) {
        return this.http.post(this.URI + this.skillListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting skill list failed in skills.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to SAVE SKILL
    * @class SkillsService
    * @method saveAllSkill
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.saveAllSkill = function (landingData) {
        return this.http.post(this.URI + this.skillSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Saving skill list failed in skills.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete SKILL
     * @class SkillsService
     * @method deleteSkill
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.deleteSkill = function (id) {
        return this.http.delete(this.URI + this.skillDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to GET USER's
   * @class
   * @method getUserDropDowns
   * @param
   * @returns Observable
   */
    SelfService.prototype.getUserDropDown = function (landingData) {
        return this.http.post(this.URI + this.userListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to GET USER's
 * @class
 * @method getUserDropDowns
 * @param
 * @returns Observable
 */
    SelfService.prototype.getUserDtls = function (landingData) {
        return this.http.post(this.URI + this.getUserDtlsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to SAVE Site
     * @class SITEService
     * @method saveAllSite
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.saveAllSite = function (landingData) {
        return this.http.post(this.URI + this.siteSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            console.log('data printing' + JSON.stringify(data));
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Saving skill list failed in skills.component.ts', '', error);
            console.log('error printing' + JSON.stringify(error));
            throw of(error);
        }));
    };
    /** For service call to GET BPG's
     * @class BPGService
     * @method getAllBpg
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.getAllSite = function () {
        return this.http.post(this.URI + this.siteListApi, this.landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Sites for Map
   * @class BPGService
   * @method getAllSitesforMap
   * @param landingData
   * @returns Observable
   */
    SelfService.prototype.getsiteMap = function (landingData) {
        return this.http.post(this.URI + this.siteMapApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Sites for Naac Home Screen
   * @class BPGService
   * @method getMapDataforNaac
   * @param landingData
   * @returns Observable
   */
    SelfService.prototype.getMapDataforNaac = function (landingData) {
        return this.http.post(this.URI + this.getMapDataforNaacApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Bpg for Map
   * @class BPGService
   * @method getEachBpgforMap
   * @param landingData
   * @returns Observable
   */
    SelfService.prototype.getEachBpg = function (landingData) {
        return this.http.post(this.URI + this.eachBpgApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete Site
     * @class BPGService
     * @method deleteBpg
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.deleteSite = function (id) {
        return this.http.delete(this.URI + this.siteDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET CHAPTER
    * @class ChapterService
    * @method getAllSkill
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.getAllChapter = function (landingData) {
        return this.http.post(this.URI + this.chapterListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to SAVE CHAPTER
    * @class ChapterService
    * @method saveAllSkill
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.saveAllChapter = function (landingData) {
        return this.http.post(this.URI + this.chapterSaveApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Saving skill list failed in skills.component.ts', '', error);
            console.log('error printing' + JSON.stringify(error));
            throw of(error);
        }));
    };
    /** For service call to Delete CHAPTER
     * @class ChapterService
     * @method deleteChapter
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.deleteChapter = function (id) {
        return this.http.delete(this.URI + this.chapterDeleteApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to GET BPG's
    * @class SelfService
    * @method getAllSites
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.getAllSiteList = function (landingData) {
        return this.http.post(this.URI + this.listAllSitesApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Chapters
     * @class SelfService
     * @method getAllChapters
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.getAllChapterList = function (landingData) {
        return this.http.post(this.URI + this.listAllChaptersApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting chapter list failed in chapter.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Chapters
   * @class SelfService
   * @method getAllChapterswithAllStatus
   * @param landingData
   * @returns Observable
   */
    SelfService.prototype.getFullChapterList = function (landingData) {
        return this.http.post(this.URI + this.listFullChaptersApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            // this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting chapter list failed in chapter.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET BPG pages list
     * @class SelfService
     * @method getBpgListPage
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.getBpgListPage = function (landingData) {
        return this.http.post(this.URI + this.bpgPageApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting bpg page list failed in bpg.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Skill list as page
   * @class SelfService
   * @method getSkillListPage
   * @param landingData
   * @returns Observable
   */
    SelfService.prototype.getSkillListPage = function (landingData) {
        return this.http.post(this.URI + this.skillPageApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting skill page list failed in skill.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET Area of impact list as page
    * @class SelfService
    * @method getAreaOfImpactListPage
    * @param landingData
    * @returns Observable
    */
    SelfService.prototype.getAreaOfImpactListPage = function (landingData) {
        return this.http.post(this.URI + this.areaOfImpactPageApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to GET CHAPTER
     * @class ChapterService
     * @method getChapterByBpg
     * @param landingData
     * @returns Observable
     */
    SelfService.prototype.getChapterByBpg = function (landingData) {
        return this.http.post(this.URI + this.chapterListByBpgApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get bpg di master List
     * @class diService
     * @method getDiMasterList
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.getDiMasterList = function (landingData) {
        return this.http.post(this.URI + this.getDiMasterListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di news List
      * @class diService
      * @method getDiNewsList
      * @param landingData
      * @returns Observable
      **/
    SelfService.prototype.getDiNewsList = function (landingData) {
        return this.http.post(this.URI + this.getDiNewsListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg NAAC news List
    * @class diService
    * @method getnaacnewsList
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.getnaacnewsList = function (landingData) {
        return this.http.post(this.URI + this.getnaacNewsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg NAAC Affinity List
  * @class naacService
  * @method getnaacAffinityList
  * @param landingData
  * @returns Observable
  **/
    SelfService.prototype.getnaacAffinityList = function (landingData) {
        return this.http.post(this.URI + this.getnaacAffinityListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to update new site
* @class NavigationComponent
* @method updateNewSite
* @param landingData
* @returns Observable
**/
    SelfService.prototype.updateNewSite = function (siteData) {
        return this.http.post(this.URI + this.updateNewSiteApi, siteData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di resource List
     * @class diService
     * @method getDiResouceList
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.getDiResouceList = function (landingData) {
        return this.http.post(this.URI + this.getDiResouceListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di reTeam List
    * @class diService
    * @method getReteamList
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.getReteamList = function (landingData) {
        return this.http.post(this.URI + this.getReteamListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg naac reTeam List
     * @class diService
     * @method getReteamList
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.getnaacREteam = function (landingData) {
        return this.http.post(this.URI + this.getnaacREteamApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get chapter board member list
   * @class selfService
   * @method getChapterBoardMember
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.getChapterBoardMember = function (landingData) {
        return this.http.post(this.URI + this.getChapterBoardMemberApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get status of chapter status
   * @class selfService
   * @method getChapterStatus
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.getChapterStatus = function (landingData) {
        return this.http.post(this.URI + this.getChapterStatusApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg naac event List
   * @class naacService
   * @method getNaacEvents
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.getNaacEvents = function (landingData) {
        return this.http.post(this.URI + this.getNaacEventsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg di master List
     * @class diService
     * @method diAddMaster
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.diAddMaster = function (diData) {
        return this.http.post(this.URI + this.diAddMasterApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add naac Banner
   * @class diService
   * @method naacMaster
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.addnaacMaster = function (naacData) {
        return this.http.post(this.URI + this.addnaacMasterApi, naacData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to delete Naac banner image
   * @class bannerImage
   * @method getdiBannerList
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.deleteNaacBanner = function (id) {
        return this.http.delete(this.URI + this.deleteNaacBannerApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to delete Naac
   * @class bannerImage
   * @method getdiBannerList
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.deleteNaacAffinity = function (id) {
        return this.http.delete(this.URI + this.deleteNaacAffinityApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to add bpg di news List
      * @class diService
      * @method diAddNews
      * @param landingData
      * @returns Observable
      **/
    SelfService.prototype.diAddNews = function (diData) {
        return this.http.post(this.URI + this.diAddNewsApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg NAAC news List
    * @class diService
    * @method naacAddNews
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.addnaacNews = function (naacNews) {
        return this.http.post(this.URI + this.addnaacNewsApi, naacNews, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg NAAC news List
  * @class diService
  * @method naacAddAffinity
  * @param landingData
  * @returns Observable
  **/
    SelfService.prototype.naacAddAffinity = function (naacNews) {
        return this.http.post(this.URI + this.naacAddAffinityApi, naacNews, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get dashboard details
* @class naacService
* @method getDashboardDetails
* @param landingData
* @returns Observable
**/
    SelfService.prototype.getsiteDetails = function (dashBoardData) {
        return this.http.post(this.URI + this.getsiteDetailsApi, dashBoardData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get dashboard details
* @class naacService
* @method getDashboardDetails
* @param landingData
* @returns Observable
**/
    SelfService.prototype.getSummaryDetails = function (summaryData) {
        return this.http.post(this.URI + this.getSummaryDetailsApi, summaryData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg di resource List
     * @class diService
     * @method diAddResource
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.diAddResource = function (diData) {
        return this.http.post(this.URI + this.diAddResourceApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg di reTeam List
     * @class diService
     * @method diReTeamAdd
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.diReTeamAdd = function (diData) {
        return this.http.post(this.URI + this.diReTeamAddApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg di reTeam List
     * @class diService
     * @method diReTeamAdd
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.addnaacReTeam = function (userData) {
        return this.http.post(this.URI + this.addnaacReTeamApi, userData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            console.log(data);
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add chapter board member
   * @class selfService
   * @method addChapterBoardMember
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.addChapterBoardMember = function (userData) {
        return this.http.post(this.URI + this.addChapterBoardMemberApi, userData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            console.log(data);
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg naac resource List
 * @class naacService
 * @method naacReTeamAdd
 * @param landingData
 * @returns Observable
 **/
    SelfService.prototype.addnaacResource = function (diData) {
        return this.http.post(this.URI + this.addnaacResourceApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add bpg di naac List
    * @class diService
    * @method diNaacAdd
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.diNaacAdd = function (diData) {
        return this.http.post(this.URI + this.diNaacAddApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di naac List
     * @class diService
     * @method getNaacList
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.getNaacList = function (diData) {
        return this.http.post(this.URI + this.getNaacListApi, diData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to delete bpg  all di
     * @class diService
     * @method deleteDi
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.deleteDi = function (deleteData) {
        return this.http.post(this.URI + this.deleteDiApi, deleteData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to delete bpg  all di
     * @class diService
     * @method deleteDi
     * @param landingData
     * @returns Observable
     **/
    SelfService.prototype.deletenaac = function (deleteData) {
        return this.http.post(this.URI + this.deletenaacApi, deleteData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to delete chapter board member
   * @class selfService
   * @method deleteChapterBoard
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.deleteChapterBoard = function (id) {
        return this.http.delete(this.URI + this.deleteChapterBoardMemberApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to upload to s3 bucket
       * @class diService
       * @method diput
       * @param url
       * @returns Observable
       */
    SelfService.prototype.diput = function (url, body) {
        var _this = this;
        var hdr = {
            'Content-Type': 'application/octet-stream'
        };
        var options = { headers: hdr };
        return new Promise(function (resolve, reject) {
            _this.http.put(url, body, options).toPromise().then(function (res) {
                return resolve(res);
            }, function (error) { return reject(error); });
        });
    };
    /** For service call to add chapter-gallery item
    * @class chapterGalleryService
    * @method addGallery
    * @param galleryData
    * @returns Observable
    **/
    SelfService.prototype.addGallery = function (galleryData) {
        return this.http.post(this.URI + this.addGalleryApi, galleryData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add chapter-announcement item
  * @class chapterGalleryService
  * @method addAnnouncement
  * @param galleryData
  * @returns Observable
  **/
    SelfService.prototype.addchapterAnnouncement = function (announcementData) {
        return this.http.post(this.URI + this.addChapterAnnouncementApi, announcementData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di naac List
    * @class chapterGalleryService
    * @method getChapterGallery
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.getChapterGalleryList = function (landingData) {
        return this.http.post(this.URI + this.getGalleryListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to track podcast views
  * @class PoddastService
  * @method PoddastService
  * @param landingData
  * @returns Observable
  **/
    SelfService.prototype.trackPostCastViews = function (landingData) {
        return this.http.post(this.URI + this.trackPostCastViewsApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di naac List
    * @class chapterGalleryService
    * @method getChapterGallery
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.getChapterAnnouncementList = function (landingData) {
        return this.http.post(this.URI + this.getChapterAnnouncementListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to send chapter feedback
  * @class chapterGalleryService
  * @method getChapterGallery
  * @param landingData
  * @returns Observable
  **/
    SelfService.prototype.sendChapterFeedback = function (feedbackData) {
        return this.http.post(this.URI + this.sendChapterFeedbackApi, feedbackData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get chapter feedback
* @class chapterGalleryService
* @method getChapterGallery
* @param landingData
* @returns Observable
**/
    SelfService.prototype.getChapterFeedback = function (feedbackData) {
        return this.http.post(this.URI + this.getChapterFeedbackApi, feedbackData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to send chapter notification
* @class chapterGalleryService
* @method getChapterGallery
* @param landingData
* @returns Observable
**/
    SelfService.prototype.sendChapterNotification = function (notificationData) {
        return this.http.post(this.URI + this.sendChapterNotificationApi, notificationData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            throw of(error);
        }));
    };
    /** For service call to get banner image
  * @class bannerImage
  * @method getdiBannerList
  * @param landingData
  * @returns Observable
  **/
    SelfService.prototype.getdiBannerList = function (landingData) {
        return this.http.post(this.URI + this.getBannerListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get naac banner data
  * @class bannerImage
  * @method getnaacBannerList
  * @param landingData
  * @returns Observable
  **/
    SelfService.prototype.getnaacBannerList = function (landingData) {
        return this.http.post(this.URI + this.getnaacBannerListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get banner image
   * @class bannerImage
   * @method getdiBannerList
   * @param landingData
   * @returns Observable
   **/
    SelfService.prototype.deleteBannerList = function (id) {
        return this.http.delete(this.URI + this.deleteBannerApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to Delete CHAPTER
   * @class chapterGalleryService
   * @method deleteGallery
   * @param landingData
   * @returns Observable
   */
    SelfService.prototype.deleteGallery = function (id) {
        return this.http.delete(this.URI + this.deleteChapterGallery + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to Delete CHAPTER Announcement
 * @class chapterGalleryService
 * @method deleteChapterAnnouncement
 * @param landingData
 * @returns Observable
 */
    SelfService.prototype.deleteChapterAnnouncement = function (id) {
        return this.http.delete(this.URI + this.deleteChapterAnnouncementApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to add chapter-gallery item
   * @class chapterGalleryService
   * @method addGallery
   * @param galleryData
   * @returns Observable
   **/
    SelfService.prototype.addDocumentsFolder = function (folderData) {
        return this.http.post(this.URI + this.addDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add di Resourc Folder
 * @class addDiDocumentsFolderService
 * @method addDiDocumentsFolderService
 * @param addFolder
 * @returns Observable
 **/
    SelfService.prototype.addDiDocumentsFolder = function (folderData) {
        return this.http.post(this.URI + this.addDiDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to add naac Resourc Folder
* @class addNaacDocumentsFolderService
* @method addNaacDocumentsFolderService
* @param addFolder
* @returns Observable
**/
    SelfService.prototype.addNaacDocumentsFolder = function (folderData) {
        return this.http.post(this.URI + this.addNaacDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get di Resourc Folder
* @class getDiDocumentsFolderService
* @method getDiDocumentsFolderService
* @param getFolder
* @returns Observable
**/
    SelfService.prototype.getDiDocumentsFolder = function (folderData) {
        return this.http.post(this.URI + this.getDiDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get naac Resourc Folder
* @class getNaacDocumentsFolderService
* @method getNaacDocumentsFolderService
* @param getFolder
* @returns Observable
**/
    SelfService.prototype.getNaacDocumentsFolder = function (folderData) {
        return this.http.post(this.URI + this.getNaacDocumentsFolderApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get NAAC Resourc Folder
* @class getnaacResource
* @method getnaacResource
* @param getFolder
* @returns Observable
**/
    SelfService.prototype.getnaacResource = function (folderData) {
        return this.http.post(this.URI + this.getnaacResourceApi, folderData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to get bpg di naac List
    * @class chapterGalleryService
    * @method getChapterGallery
    * @param landingData
    * @returns Observable
    **/
    SelfService.prototype.getDocumentsFolderList = function (landingData) {
        return this.http.post(this.URI + this.getDocumentsFolderListApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For service call to Delete Folder
  * @class deleteDocumentsFolderService
  * @method deleteDocumentsFolder
  * @param landingData
  * @returns Observable
  */
    SelfService.prototype.deleteDocumentsFolder = function (id) {
        return this.http.delete(this.URI + this.deleteDocumentsFolderApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to Delete CHAPTER
* @class chapterGalleryService
* @method deleteGallery
* @param landingData
* @returns Observable
*/
    SelfService.prototype.deleteDiDocumentsFolder = function (id) {
        return this.http.delete(this.URI + this.deleteDiDocumentsFolderApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to Delete NaacDocuments
* @class chapterGalleryService
* @method deleteGallery
* @param landingData
* @returns Observable
*/
    SelfService.prototype.deleteNaacDocumentsFolder = function (id) {
        return this.http.delete(this.URI + this.deleteNaacDocumentsFolderApi + id, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }));
    };
    /** For service call to get membership details for membership report
 * @class SelfService
 * @method getMembershipReport
 * @param landingData
 * @returns Observable
 **/
    SelfService.prototype.getMembershipReport = function (landingData) {
        return this.http.post(this.URI + this.membershipReportApi, landingData, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        })).pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting area of impact page list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    /** For converting json to csv and saving the file
     * @class SelfService
     * @method exportAsExcelFile
     * @param json data, string
     */
    SelfService.prototype.exportAsExcelFile = function (json, excelFileName) {
        var worksheet = XLSX.utils.json_to_sheet(json);
        var workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        var excelBuffer = XLSX.write(workbook, { bookType: 'csv', type: 'array' });
        this.saveAsExcelFile(excelBuffer, excelFileName);
    };
    SelfService.prototype.saveAsExcelFile = function (buffer, fileName) {
        var data = new Blob([buffer], { type: EXCEL_TYPE });
        FileSaver.saveAs(data, fileName.trim() + EXCEL_EXTENSION);
    };
    /** For service call to GET BPG's
 * @class BPGService
 * @method getMemershipSites
 * @param landingData
 * @returns Observable
 */
    SelfService.prototype.getMembershipSites = function (userId) {
        return this.http.get(this.URI + this.membershipSitesApi + userId, this.bpgCommonService.tokenizedHeader()).pipe(map(function (data) {
            return data;
        }))
            .pipe(catchError(function (error) {
            //  this.logger.logException(ConstantValues.modules.selfServiceModule, '', 'Getting demographics list failed in area-of-impact.component.ts', '', error);
            throw of(error);
        }));
    };
    SelfService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SelfService_Factory() { return new SelfService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.BpgCommonService)); }, token: SelfService, providedIn: "root" });
    return SelfService;
}());
export { SelfService };
